import api from "../store/services/api";
import TokenService from "../store/services/token.service";

export const getKitchenBoard = () => api.get("/kitchen/board/");

export const startPreparation = (orderId) =>
  api.post(`/kitchen/orders/${encodeURIComponent(orderId)}/start/`);

export const finishPreparation = (orderId) =>
  api.post(`/kitchen/orders/${encodeURIComponent(orderId)}/finish/`);

export const getVoiceChefStatus = () => api.get("/kitchen/voice-chef/status/");

/**
 * Mints a single-use Gemini Live token whose prompt carries every order in
 * preparation. `orderId` is optional: it only checks that order is in preparation.
 */
export const createVoiceChefSession = (orderId) =>
  api.post("/kitchen/voice-chef/sessions/", orderId ? { order_id: orderId } : {});

/** Adds an order to a live session; returns the server-written text to forward to the chef. */
export const addOrderToVoiceChefSession = (sessionId, orderId) =>
  api.post(`/kitchen/voice-chef/sessions/${sessionId}/orders/`, { order_id: orderId });

/** The chef called `registrar_duvida`: relay it so the doubt is kept for review. */
export const recordVoiceChefDoubt = (sessionId, payload) =>
  api.post(`/kitchen/voice-chef/sessions/${sessionId}/doubts/`, payload);

/**
 * Grounding check for one finished chef turn. Returns `correction` when the chef
 * said a figure or order number that is not in the session's data.
 */
export const checkVoiceChefTurn = (sessionId, payload) =>
  api.post(`/kitchen/voice-chef/sessions/${sessionId}/check/`, payload);

/**
 * Settle the minutes used. `keepalive` lets the request outlive the page, so
 * closing the tab mid-session still returns the unused minutes — which is why
 * this uses fetch rather than axios.
 */
export const endVoiceChefSession = (sessionId, payload) =>
  fetch(`${api.defaults.baseURL}/kitchen/voice-chef/sessions/${sessionId}/end/`, {
    method: "POST",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${TokenService.getLocalAccessToken()}`,
    },
    body: JSON.stringify(payload),
  }).catch(() => {});

export const getAddons = () => api.get("/subscriptions/addons/");

export const createAddonCheckout = (code) =>
  api.post(`/subscriptions/addons/${code}/checkout/`);
